module.exports = __webpack_public_path__ + "static/new_feat-c3d3523c2f972c684c3ab2a2065f1cab.png";